import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import foBus from "utils/foBus";

import "./index.scss";
import utils from "../../utils/utils";

class AppLayout extends React.Component {
  constructor(props) {
    super(props);

    this.handleRefreshContent = this.handleRefreshContent.bind(this);
  }

  componentDidMount() {
    foBus.addEventListener(
      foBus.KEYS.refreshContent,
      this.handleRefreshContent
    );
  }

  componentWillUnmount() {
    foBus.removeEventListener(
      foBus.KEYS.refreshContent,
      this.handleRefreshContent
    );
  }

  handleRefreshContent() {
    window.location.reload();
  }

  renderNavBar() {
    return this.props.navBar;
  }

  renderFootBar() {
    return this.props.footBar;
  }

  renderBody() {
    let content = this.props.children;
    // 默认微信下不要加inner, 因为CmpScrollView无法自动计算父容器高度
    if (utils.isFoApp()) {
      //  这里加inner, 是为了方便在App下调整高度时, 计算内部容器的高度
      content = <div className="appLayout-body-inner">{content}</div>;
    }
    const { canScroll } = this.props;
    const klass = utils.classnames("appLayout-body", {
      "can-scroll": canScroll
    });

    return (
      <div className={klass}>
        {content}
        {/*<div className="appLayout-body-marginTopMinus1" />*/}
      </div>
    );
  }

  render() {
    return (
      <div className={classnames("appLayout", this.props.className)}>
        {this.renderNavBar()}
        {this.renderBody()}
        {this.renderFootBar()}
      </div>
    );
  }
}

AppLayout.propTypes = {
  footBar: PropTypes.node,
  navBar: PropTypes.node,
  className: PropTypes.string,
  canScroll: PropTypes.bool
};
AppLayout.defaultProps = {
  canScroll: true
};

export default AppLayout;



// WEBPACK FOOTER //
// ./src/components/AppLayout/index.js